var map = {
	"./CheckoutPage.js": 4207,
	"./CheckoutRedirect.js": 9675,
	"./ConfirmationPage.js": 7965,
	"./ConfirmationRedirect.js": 9921,
	"./ContactPage.js": 7340,
	"./ContactRedirect.js": 5376,
	"./HomePage.js": 7948,
	"./HomeRedirect.js": 2923,
	"./MapSection.js": 3150,
	"./MenuPage.js": 4744,
	"./MenuRedirect.js": 6610,
	"./MenuSection.js": 3259,
	"./NotFoundPage.js": 2665,
	"./OrderPage.js": 3547,
	"./OrderRedirect.js": 5483,
	"./TablePage.js": 7702,
	"./TableRedirect.js": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5464;